import {createRoot, hydrateRoot} from 'react-dom/client';
import GetStarted from '../pages/GetStarted/GetStarted'
import "../index.css";
import "../pages/GetStarted/GetStarted.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<GetStarted {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <GetStarted {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).GetStartedVC = {mount, hydrate, unmount}